export const latestChangesData = [
  {
    key: 1,
    title: "Google Sign-In",
    publishedOn: "14 days ago",
    status: "New",
    summary: `<p>You can now login into Headway with any Google account, and we highly recommend it. Not
      only its one less password to remember but google offers extra level of security with <a href="#">two-factor 
      authentication</a> options.</p><p>To connect your Google account, simply navigate to <i>Settings -> Profile</i>
      and select how you want to log into your account.</p>
      <div><b>Log in with:</b></div><img src="https://i.ibb.co/0MvpFKL/google-account-button.png" alt="google-account-button"/>`
  },
  {
    key: 2,
    title: "Delay in publishing changelogs",
    publishedOn: "a month ago",
    status: "Fix",
    summary: `<p>Some scheduled changelogs, tweets and slack messages queued up this weekend and were not
    pulished on time. We fixed the issue and all</p>`
  },
  {
    key: 3,
    title: "Changing the author",
    publishedOn: "two months ago",
    status: "Fix",
    summary: "We have now changed the author as well"
  },
]